import { SliceCaseReducers } from '@reduxjs/toolkit'
import { EditAliasPayload } from '@repo/accounts-types'
import { createOperationSlice, GenericOperationState } from '@repo/core'

const initialState: GenericOperationState<EditAliasPayload> = {
  payload: {
    id: '',
    alias: '',
  },
  meta: { fetchState: 'initial' },
  error: false,
}

export const { actions: editAliasDataActions, reducer: editAliasDataReducer } =
  createOperationSlice<
    EditAliasPayload,
    SliceCaseReducers<GenericOperationState<EditAliasPayload>>,
    EditAliasPayload
  >({
    name: '@accounts/detail/write/editAliasData',
    initialState,
    reducers: {},
  })
